'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject;
var SFavorite = styled__default["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    align-items: flex-start;\n    cursor: pointer;\n    display: flex;\n    position: absolute;\n    right: ", ";\n    top: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  return size === 'small' ? theme.space[8] : theme.space[16];
}, function (_ref2) {
  var theme = _ref2.theme,
    size = _ref2.size;
  return size === 'small' ? theme.space[10] : theme.space[18];
});

exports.SFavorite = SFavorite;
//# sourceMappingURL=Favorite.style.js.map
